<template>
    <a-row :gutter="24">
        <a-col :md="24">
            <a-card :bordered="false">
                <div class="trace-code-container">
                    
                    <!-- <a-steps :current="currentStep">
                        <a-step title="生码" />
                        <a-step title="产品信息" />
                        <a-step title="扫码" />
                        <a-step title="完成" />
                    </a-steps> -->
                    <div v-if="currentStep === 0">
                        <a-form-model ref="form" :model="form" :rules="rules" class="form-container">
                        <a-form-model-item 
                            v-for="item in formItems" 
                            :key="item.keyCode" 
                            :label="item.keyName" 
                            :prop="item.keyCode" 
                            class="form-item"
                            v-if=" item.keyType !== '5' && item.keyType !== '6'"
                        >
                            <a-row :gutter="8">
                                <a-col :span="24" :md="24">
                                    <template v-if="item.keyType === '0'">
                                        <!--  || item.keyType !== '5' -->
                                        <a-input v-model="form[item.keyCode]" disabled/>
                                    </template>
                                    <template v-else-if="item.keyType === '1'">
                                        <!--  || item.keyType !== '5' -->
                                        <a-input v-model="form[item.keyCode]" />
                                    </template>
                                    <template v-else-if="item.keyType === '2'">
                                        <a-date-picker
                                            v-model="form[item.keyCode]"
                                            show-time
                                            format="YYYY-MM-DD HH:mm:ss"
                                            value-format="YYYY-MM-DD HH:mm:ss"
                                        />
                                    </template>
                                </a-col>
                            </a-row>
                            <a-row v-if="item.keyType === '3' || item.keyType === '4'">
                                <a-col :span="24">
                                    
                                    <a-select v-model="form[item.keyCode]" @change="handleChange($event, item.keyCode)">
                                        <a-select-option
                                            v-for="option in formOptions[item.keyCode]"
                                            :key="option.dictValue"
                                            :value="option.dictValue"
                                            
                                        >
                                            {{ option.dictLable }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                            </a-row>
                            <!-- <a-row v-if="item.keyType === '6'">
                                <a-col :span="24">
                                    <a-input v-model="form[item.keyCode]" :value="getCurrentDate()" />
                                </a-col>
                            </a-row> -->
                            </a-form-model-item>
                            <a-form-model-item class="ensureBox" >
                                <a-button type="primary" @click="handleSubmit">填写产品信息</a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </div>
                    <div v-else-if="currentStep === 1">
                        <!-- 展示追溯模版 -->
                        <TraceModule ref="traceModules" :traceVueModule="traceVueModule" @getDrawingList="handleGetDrawingList" :isStep="isStep"></TraceModule>
                        <div class="ensureBox">
                            <a-button type="primary" @click="handleSave">保存</a-button>
                            <!-- <a-button type="primary" @click="handleTraceSubmit">去扫码</a-button>
                            <a-button type="primary" @click="handleTracePrint" style="margin-left: 20px;">去打印</a-button> -->
                        </div>
                        <!-- <a-form-model :model="formData" :rules="rules" ref="formRef" class="traceForm-container">
                            <a-form-model-item 
                                v-for="(item, index) in templateData"
                                :key="item.renderKey"
                                :label="item.label" 
                                :prop="item.vModel"
                                :rules="item.rules"
                            >
                                <a-select
                                    v-if="item.tag == 'el-select'"
                                    v-model="traceFormItems[item.vModel]"
                                    :style="item.style"
                                    :placeholder="item.placeholder"
                                    :disabled="item.disabled"
                                    :clearable="item.clearable"
                                    >
                                    <a-select-option
                                        v-for="option in item.options"
                                        :key="option.value"
                                        :value="option.value"
                                    >
                                        {{ option.label }}
                                    </a-select-option>
                                </a-select>
                                <a-radio-group
                                    v-else-if="item.tag == 'el-radio-group'"
                                    v-model="traceFormItems[item.vModel]"
                                    :style="item.style"
                                    :placeholder="item.placeholder"
                                    :disabled="item.disabled"
                                    :clearable="item.clearable"
                                    
                                    >
                                    <a-radio
                                        v-for="option in item.options"
                                        :key="option.value"
                                        :value="option.value"
                                    >
                                        {{ option.label }}
                                    </a-radio>
                                    
                                </a-radio-group>
                                <a-upload 
                                    :name='item.name'
                                    v-model="traceFormItems[item.vModel]"
                                    v-else-if="item.tag == 'el-upload'"
                                    :multiple='true'
                                    :headers="item.headers"
                                    :data="item.data"
                                    :show-file-list="item.showFileList"
                                    :list-type="item.listType"
                                    :accept="item.accept"
                                    :action='item.action'
                                    :before-upload="item.beforeUpload"
                                    @change="handleChangeFile"
                                >
                                    <a-button><a-icon type="upload"></a-icon>{{item.buttonText}}</a-button>
                                </a-upload>
                                
                                <component
                                    v-else
                                    :is="item.tag"
                                    v-model="traceFormItems[item.vModel]"
                                    :label="item.label"
                                    :placeholder="item.placeholder"
                                    :disabled="item.disabled"
                                    :readonly="item.readonly"
                                    :required="item.required"
                                    :style="item.style"
                                    :clearable="item.clearable"
                                    :show-word-limit="item['show-word-limit']"
                                    :prefix-icon="item['prefix-icon']"
                                    :suffix-icon="item['suffix-icon']"
                                    :prepend="item.prepend"
                                    :append="item.append"
                                    :value="formattedValue(item.vModel)"
                                    :options="item.options"
                                />
                                <form-item-renderer v-if="item.children" :items="item.children" :traceFormItems="traceFormItems" :handleChangeFile="handleChangeFile" />
                            </a-form-model-item>
                            <a-form-model-item class="ensureBox">
                                <a-button type="primary" @click="handleTraceSubmit">去扫码</a-button>
                                <a-button type="primary" @click="handleTracePrint" style="margin-left: 20px;">去打印</a-button>
                            </a-form-model-item>
                        </a-form-model> -->
                    </div>
                    <div v-else-if="currentStep === 2">
                        <div v-if="currentView === 'scan'">
                            <a-tabs default-active-key="1" @change="handleTabChange">
                                <a-tab-pane key="1" tab="扫码">
                                    <div class="scanBox">
                                    <a-button @click="handleScanStart" class="startScan">开始扫码</a-button>
                                    <div class="scanContent">
                                        <a-list>
                                            <a-list-item v-for="(item, index) in scanData" :key="index">
                                                {{ index + 1 }}. {{ item }}
                                            </a-list-item>
                                        </a-list>
                                    </div>
                                    </div>
                                    <div class="ensureBox">
                                    <a-button type="primary" @click="handleScan">提交</a-button>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane key="2" tab="码段">
                                    <!-- 其他内容 -->
                                    <a-list>
                                        <a-list-item v-for="(item, index) in getProductCode" :key="index">
                                            {{ index + 1 }}. {{ item.idCode }}
                                        </a-list-item>
                                    </a-list>
                                    <div class="ensureBox">
                                        <a-button type="primary" @click="handleActive">码段提交</a-button>
                                    </div>
                                    <!-- 点击去激活按钮弹出modal，表单配置激活序号从哪到哪的码 -->
                                    <a-modal
                                        title="配置码段"
                                        :visible="activeVisible"
                                        @ok="handleActiveOk"
                                        @cancel="handleActiveCancel"
                                    >
                                        <a-form :form="activeForm">
                                            <a-form-item label="开始" name="startCode">
                                                <a-input v-model="activeForm.startCode" placeholder="请输入开始商品码" />
                                            </a-form-item>
                                            <a-form-item label="结束" name="endCode">
                                                <a-input v-model="activeForm.endCode" placeholder="请输入结束商品码" />
                                            </a-form-item>
                                        </a-form>
                                    </a-modal>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                        <div v-else-if="currentView === 'print'">
                            <a-form-model ref="printForm" :model="printForm" :rules="rules" class="form-container">
                                <a-form-model-item 
                                    v-for="item in printItems" 
                                    :key="item.keyCode" 
                                    :label="item.keyName" 
                                    :prop="item.keyCode" 
                                    class="form-item"
                                    v-if="item.keyType !== '5'"
                                >
                                    <a-row :gutter="8">
                                        <a-col :span="24" :md="24">
                                            <template v-if="item.keyType === '0'">
                                                <a-input v-model="printForm[item.keyCode]" disabled/>
                                            </template>
                                            <template v-else-if="item.keyType === '1'">
                                                <!--  || item.keyType !== '5' -->
                                                <a-input v-model="printForm[item.keyCode]" />
                                            </template>
                                            <!-- <template v-else-if="item.keyType === '5'">
                                                <a-input v-model="printForm[item.keyCode]" />
                                            </template> -->
                                            <template v-else-if="item.keyType === '2'">
                                                <a-date-picker
                                                    v-model="printForm[item.keyCode]"
                                                    show-time
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                />
                                            </template>
                                            <!-- <template v-else-if="item.keyType === '6'">
                                                <a-date-picker
                                                    v-model="printForm[item.keyCode]"
                                                    show-time
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                />
                                            </template> -->
                                        </a-col>
                                    </a-row>
                                    <a-row v-if="item.keyType === '3' || item.keyType === '4'">
                                        <a-col :span="24">
                                            
                                            <a-select v-model="printForm[item.keyCode]" @change="handlePrintChange($event, item.keyCode)">
                                                <a-select-option
                                                    v-for="option in printOptions[item.keyCode]"
                                                    :key="option.dictValue"
                                                    :value="option.dictValue"
                                                    
                                                >
                                                    {{ option.dictLable }}
                                                </a-select-option>
                                            </a-select>
                                        </a-col>
                                    </a-row>                    
                                </a-form-model-item>
                                <!-- 添加固定的单选按钮 -->
                                <a-form-model-item label="打印个数" prop="fixedRadio">
                                    <a-radio-group v-model="printForm.fixedRadio" @change="handleRadioChange">
                                        <a-radio value="1">1</a-radio>
                                        <a-radio value="5">5</a-radio>
                                        <a-radio value="10">10</a-radio>
                                    </a-radio-group>
                                    </a-form-model-item>
                                </a-form-model>
                            <a-form-model-item class="ensureBox">
                                <a-button type="primary" @click="handlePrint">打印</a-button>
                            </a-form-model-item>
                        </a-form-model>
                        </div>
                    </div>
                    <div v-else-if="currentStep === 3">
                        <div class="completeBox">
                            <a-icon type="check-circle" style="color:#00DB00;font-size: 150px;display: block;width: 100%;"/>
                            <span class="completeText">{{completedInfo}}</span>
                        </div>
                        <div class="ensureBox">
                            <a-button type="primary" @click="handleCloseSteps">关闭</a-button>
                        </div>
                    </div>
                </div>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
    import { getCodeForm, getCodeFormDict, generateCodeByParameter, addPlan, getCodeSegmentList, getRuleMesByMaterialId, getAllModules, generateCodeForPrint } from '@/api/api'
    import {startPrint } from '@/views/UDIadmin/modules/allPrint'
    import TaskRunner from 'concurrent-tasks'
    import TraceModule from '@/views/identifierCode/traceModule.vue';
    import moment from 'moment';
    import { traceSave } from '@/api/api'
    export default {
        name: 'VendorModal',
        props: {
            ruleId: {
                type: [Number],
                required: true
            },
            processId: {
                type: [String, Number],
                required: true
            },
            craftId: {
                type: [String, Number],
                required: true
            },
            metarialInfo: {
                type: [String, Number],
                required: true
            },
        },
        components: {
            TraceModule
        },
        // components: {
        //     FormItemRenderer: {
        //         functional: true,
        //         props: {
        //             items: {
        //             type: Array,
        //             required: true
        //             },
        //             traceFormItems: {
        //             type: Object,
        //             required: true
        //             },
        //             handleChangeFile: {
        //             type: Function,
        //             required: true
        //             }
        //         },
        //         render(h, { props, parent }) {
        //             return props.items.map(item => {
        //             const children = item.children ? h(FormItemRenderer, {
        //                 props: {
        //                 items: item.children,
        //                 traceFormItems: props.traceFormItems,
        //                 handleChangeFile: props.handleChangeFile
        //                 }
        //             }) : null;
        //             return h('a-form-model-item', {
        //                 key: item.renderKey,
        //                 props: {
        //                 label: item.label,
        //                 prop: item.vModel,
        //                 rules: item.rules
        //                 }
        //             }, [
        //                 item.tag === 'el-select' ? h('a-select', {
        //                 props: {
        //                     value: props.traceFormItems[item.vModel],
        //                     style: item.style,
        //                     placeholder: item.placeholder,
        //                     disabled: item.disabled,
        //                     clearable: item.clearable
        //                 },
        //                 on: {
        //                     input: value => {
        //                     parent.$set(props.traceFormItems, item.vModel, value);
        //                     }
        //                 }
        //                 }, item.options.map(option => h('a-select-option', {
        //                     key: option.value,
        //                     props: { value: option.value }
        //                 }, option.label))) : null,
        //                 item.tag === 'el-radio-group' ? h('a-radio-group', {
        //                 props: {
        //                     value: props.traceFormItems[item.vModel],
        //                     style: item.style,
        //                     placeholder: item.placeholder,
        //                     disabled: item.disabled,
        //                     clearable: item.clearable
        //                 },
        //                 on: {
        //                     input: value => {
        //                     parent.$set(props.traceFormItems, item.vModel, value);
        //                     }
        //                 }
        //                 }, item.options.map(option => h('a-radio', {
        //                 key: option.value,
        //                 props: { value: option.value }
        //                 }, option.label))) : null,
        //                 item.tag === 'el-upload' ? h('a-upload', {
        //                 props: {
        //                     name: item.name,
        //                     fileList: props.traceFormItems[item.vModel],
        //                     multiple: true,
        //                     headers: item.headers,
        //                     data: item.data,
        //                     showFileList: item.showFileList,
        //                     listType: item.listType,
        //                     accept: item.accept,
        //                     action: item.action,
        //                     beforeUpload: item.beforeUpload
        //                 },
        //                 on: {
        //                     change: props.handleChangeFile
        //                 }
        //                 }, [
        //                 h('a-button', [
        //                     h('a-icon', { props: { type: 'upload' } }),
        //                     item.buttonText
        //                 ])
        //                 ]) : null,
        //                 item.tag && ['el-select', 'el-radio-group', 'el-upload'].indexOf(item.tag) === -1 ? h(item.tag, {
        //                 props: {
        //                     value: props.traceFormItems[item.vModel],
        //                     label: item.label,
        //                     placeholder: item.placeholder,
        //                     disabled: item.disabled,
        //                     readonly: item.readonly,
        //                     required: item.required,
        //                     style: item.style,
        //                     clearable: item.clearable,
        //                     'show-word-limit': item['show-word-limit'],
        //                     'prefix-icon': item['prefix-icon'],
        //                     'suffix-icon': item['suffix-icon'],
        //                     prepend: item.prepend,
        //                     append: item.append,
        //                     options: item.options
        //                 },
        //                 on: {
        //                     input: value => {
        //                     parent.$set(props.traceFormItems, item.vModel, value);
        //                     }
        //                 }
        //                 }) : null,
        //                 children
        //             ]);
        //             });
        //         }
        //     },
        // },
        data(){
            return {
                form: { },
                printForm: { 
                    fixedRadio: '1' // 初始化固定单选按钮的值
                },
                activeForm: { },
                formData: { },
                rules: { },
                traceVueModule : null,
                // ruleId : null,
                // processId : null,
                // craftId : null,
                currentView: 'scan', // 默认显示扫码内容
                textValue: '',
                number: '1',
                objectId: '',
                traceFormItems: [],
                formItems: [],
                printList: [],
                printItems: [],
                formOptions: {},// 修改为嵌套对象
                printOptions: {},// 修改为嵌套对象
                currentStep: 0, // 当前步骤
                stepFormItems: [], // 每个步骤的表单项
                templateData: [],
                traceFormItems: [], // 添加 traceFormItems 数组
                scanData: [],
                currentScan: '',
                isScanning: false,
                activeVisible: false,
                eventCodes: '',
                newItems: [],
                getProductCode: [],
                completedInfo: '完成',
                options: [],
                uploadUrl: process.env.VUE_APP_UPLOAD_URL,
                checkType: 1,
                getModuleInfo: {},
                formModule:[],
                traceModuleForm: {},
                isStep: false
            }
        },
        computed: {
            currentFormItems() {
                return this.stepFormItems[this.currentStep] || [];
            },
            formattedValue() {
                return (vModel) => {
                    const item = this.traceFormItems.find(i => i.vModel === vModel);
                    if (item && item.value && item.tag === 'a-date-picker') {
                        return this.formatDate(item.value);
                    }
                    return item ? item.value : '';
                };
            }
        },
        mounted(){
            console.log('Received ruleId:', this.ruleId,this.processId, this.craftId);
            this.getCodeInfo()
        },
        watch: {
            ruleId(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getCodeInfo();
                }
            }
        },
        beforeDestroy() {
            this.stopListeningForScan(); // 确保在组件销毁时移除事件监听器
        },
        methods: {
            handleTabChange(checkType){
                this.checkType = checkType;
            },
            resetCurrentStep() {
                this.currentStep = 0;
            },
            // 时间格式化
            formatDate(date) {
                if (!(date instanceof Date)) {
                    date = new Date(date);
                }
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
             // 上传前的检查
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('文件大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 处理文件上传
            handleChangeFile(info) {
                console.log(info,this.uploadUrl,'info==================')
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} 文件上传成功`);
                    // 这里可以将文件信息保存到 formData 中
                    this.$set(this.traceFormItems, 'file', this.uploadUrl + '/download/h5template/' + info.file.response.result);
                    this.fileUrl = this.uploadUrl + '/download/h5template/' + info.file.response.result;
                    console.log('上传成功===============', this.traceFormItems);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} 文件上传失败`);
                }
            },
            async getCodeInfo(){
                const params= {
                    ruleId: this.ruleId
                }
                const res = await getCodeForm(params)
                if( res.code === 200 && res.success === true ){
                    if( res.result.params ){
                        this.ruleId = res.result.uuid
                        this.formItems = res.result.params;
                        // 初始化 stepFormItems
                        this.initStepFormItems();
                        // 初始化 form 和 rules
                        this.formItems.forEach(item => {
                            if (item.keyType !== '6' || item.keyType !== '5') {
                                this.$set(this.form, item.keyCode, item.keyValue || '');

                                // 根据 keyType 设置验证规则
                                switch (item.keyType) {
                                    case '0': // 常量
                                    case '1': // 变量
                                    // case '5': // 序列号
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                                    //     break;
                                    case '2': // 日期
                                        this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                        break;
                                    case '3': // 标准字典
                                    case '4': // 自定义字典
                                        this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                        this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                                        break;
                                    // case '6': // 当前日期
                                    //     this.rules[item.keyCode] = [];
                                    //     break;
                                    default:
                                        break;
                                }
                            }
                        });
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    this.$message.error('获取数据失败')
                    console.log(this.formItems,'this.formItems还有值吗？？？？？？？？？？')
                    this.formItems = []
                }
            },
            initStepFormItems() {
                // 假设 formItems 已经按照步骤划分好
                this.stepFormItems = [
                    this.formItems.slice(0, 3), // 第一步的表单项
                    this.formItems.slice(3, 6), // 第二步的表单项
                    this.formItems.slice(6)    // 第三步的表单项
                ];
            },
            async getOptions(dicCode, keyCode) {
                // 根据 keyType 返回相应的选项
                const res = await getCodeFormDict({dictId: dicCode})
                // 把res的值赋给select
                if( res.code === 200 && res.success === true ){
                    this.$set(this.formOptions, keyCode, res.result);
                    this.$set(this.printOptions, keyCode, res.result);
                }
            },
            getCurrentDate() {
                return new Date().toISOString().split('T')[0];
            },
            // 切换获取select选中值
            handleChange(value, keyCode) {
                // 找到对应的 option 对象
                const selectedOption = this.formOptions[keyCode].find(option => option.dictValue === value);
                if (selectedOption) {
                    // 遍历 formItems，将选中的值赋给对应的 keyCode 对应的 key
                    this.formItems.forEach(item => {
                        if (item.keyCode === keyCode) {
                            item.keyDescription.itemValue = selectedOption.dictLable;
                            item.keyDescription.itemCode = selectedOption.uuid
                            item.keyValue = value
                        }
                    });
                }
            },
            handlePrintChange(value, keyCode) {
                // 找到对应的 option 对象
                const selectedOption = this.printOptions[keyCode].find(option => option.dictValue === value);
                if (selectedOption) {
                    // 遍历 formItems，将选中的值赋给对应的 keyCode 对应的 key
                    this.printItems.forEach(item => {
                        if (item.keyCode === keyCode) {
                            item.keyDescription.itemValue = selectedOption.dictLable;
                            item.keyDescription.itemCode = selectedOption.uuid
                            item.keyValue = value
                        }
                    });
                }
            },
            // 开始扫码
            handleScanStart(){
                this.isScanning = true;
                window.addEventListener('keydown', this.handleKeyPress);
            },
            handleKeyPress(event) {
                if (!this.isScanning) return;

                // 捕获扫码数据
                const key = event.key;
                console.log(key, '扫码数据');
                // 忽略 Shift 键
                if (key.toLowerCase() === 'shift') {
                    return;
                }
                // 忽略F12和ControlInsert 
                if (key === 'F12' || key === 'ControlInsert') {
                    return;
                }
                // 假设扫码结束符是回车键
                if( key === 'Enter' ){
                    this.isScanning = false;
                    window.removeEventListener('keydown', this.handleKeyPress);
                    const isExist = this.scanData.some(item => item === this.currentScan);
                    if( isExist ){
                        this.$message.error('重复')
                        this.currentScan = ''; // 清空当前累积的数据
                        this.handleScanRestart(); // 重新开始监听键盘事件
                        return
                    } else {
                        this.scanData.push(this.currentScan);
                        this.currentScan = ''; // 清空当前累积的数据
                    }
                    this.handleScanComplete(); // 新增方法，处理扫描完成后的逻辑
                    
                } else {
                    // this.currentScan += key;
                    if (key.length === 1 && key !== 'Unidentified') {
                        this.currentScan += key;
                    }
                    console.log(this.currentScan,'this.currentScan==============')
                }
            },
            handleScanComplete() {
                // 重新开始监听键盘事件
                this.isScanning = true;
                window.addEventListener('keydown', this.handleKeyPress);
            },
            handleScanRestart() {
                // 重新开始监听键盘事件
                this.isScanning = true;
                window.addEventListener('keydown', this.handleKeyPress);
            },
            // 生码提交
            handleSubmit(){
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitGenerateCode();
                    } else {
                        console.log('表单验证失败');
                        return false;
                    }
                });
            },
            async submitGenerateCode(){
                const params = {
                    params: JSON.stringify(this.formItems),
                    ruleId: this.ruleId,
                    processId: this.processId
                }
                const res = await generateCodeByParameter(params)
                console.log(res,'生码结果===============')
                if( res.code === 200 && res.success == true ){
                    // this.$message.success('生码成功')
                    console.log(res.result,'res.result===============')
                    this.eventCodes = res.result.code
                    this.currentStep = 1;
                    this.isStep = true;
                    this.traceVueModule = res.result.templateData
                    console.log(typeof(this.traceVueModule),this.traceVueModule,'this.traceVueModule===============')
                    this.templateData = res.result.templateData
                    this.traceFormItems = res.result.templateData
                    // 初始化 traceFormItems
                    // this.traceFormItems = this.templateData.map(item => ({
                    //     label: item.label,
                    //     vModel: item.vModel,
                    //     value: item.value || '', // 如果有初始值，可以设置在这里
                    //     placeholder: item.placeholder || '',
                    //     disabled: item.disabled || false,
                    //     readonly: item.readonly || false,
                    //     required: item.required || false,
                    //     style: item.style || {},
                    //     name: item.name || '',
                    //     tag: item.tag || '',
                    //     ltagIcon: item.ltagIcon || '',
                    //     clearable: item.clearable || false,
                    //     'show-word-limit': item['show-word-limit'] || false,
                    //     'prefix-icon': item['prefix-icon'] || '',
                    //     'suffix-icon': item['suffix-icon'] || '',
                    //     prepend: item.prepend || '',
                    //     append: item.append || '',
                    //     options: item.options || [],
                    // }));
                    console.log(this.traceFormItems,'formData121212=================')
                } else {
                    this.$message.error('生码失败,请检查表单信息！')
                }
            },
            // 处理接收的数据
            handleGetDrawingList(drawingList){
                console.log(drawingList,'drawingList===============')
            },
            // 追溯模版确认提交
            handleTraceSubmit(){
                this.currentView = 'scan';
                // 调用子组件的save方法
                this.$refs.traceModules.save();
                // 获取traceFormItems的label
                console.log(this.traceFormItems,'this.formData===========')
                
                // 遍历 this.traceFormItems 并更新每个表单项的 value
                this.traceFormItems = this.traceFormItems.map(item => {
                    let value = this.traceFormItems[item.vModel] || '';
                    // 检查 value 是否为 Date 类型
                    if (value instanceof Date) {
                        // 使用 moment.js 格式化日期
                        value = moment(value).format('YYYY-MM-DD HH:mm:ss');
                    }
                    // 如果 是文件对象，把traceFormItems.file值赋给对应的item的value
                    
                    if (item.name  == 'file') {
                        value = this.fileUrl
                    }
                    return {
                        ...item,
                        value: value
                    }
                });
                console.log(this.traceFormItems,'55555formData=================')
                localStorage.setItem('traceFormItems', JSON.stringify(this.traceFormItems))
                this.currentStep = 2
                this.getCodeSegmentList()
            },
            async handleSave(){
                const operatorTime = new Date().getTime()
                const planDate = moment(operatorTime).format('YYYY-MM-DD HH:mm:ss');
                const params = {
                    craftId: this.craftId,
                    traceCode: this.eventCodes,
                    materialId: this.metarialInfo,
                    planDate: planDate,
                    procSeq: this.procSeq,
                    processId: this.processId,
                    formData: this.traceFormItems
                }
                const res = await addPlan(params)
                if( res.code === 200 && res.success == true ){
                    this.$message.success(res.result)
                    this.currentStep = 0
                    this.activeVisible = false
                } else {
                    this.$message.error(res.result)
                }
            },
            handleRadioChange(event){
                console.log('Selected radio value:', event.target.value);
                this.number = event.target.value
            },
            // 去打印获取表单信息
            async handleTracePrint(){
                this.currentView = 'print';
                this.currentStep = 2
                const params = {
                    materialId: this.metarialInfo,
                } 
                const res = await getRuleMesByMaterialId(params)
                console.log(res,'码段列表===============')
                if( res.code == 200 && res.success == true ){
                    // this.getProductCode = res.result.records
                    this.objectId = res.result.uuid
                    this.printItems = res.result.params;
                        // 初始化 stepFormItems
                        this.initStepPrintItems();
                        // 初始化 form 和 rules
                        this.printItems.forEach(item => {
                            if (item.keyType !== '6' || item.keyType !== '5') {
                                this.$set(this.printForm, item.keyCode, item.keyValue || '');

                                // 根据 keyType 设置验证规则
                                switch (item.keyType) {
                                    case '0': // 常量
                                    case '1': // 变量
                                    case '5': // 序列号
                                        this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                                        break;
                                    case '2': // 日期
                                        this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                        break;
                                    case '3': // 标准字典
                                    case '4': // 自定义字典
                                        this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                        this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                                        break;
                                    case '6': // 当前日期
                                        this.rules[item.keyCode] = [];
                                        break;
                                    default:
                                        break;
                                }
                                // if ( item.keyType === '5' ){
                                //     item.keyName = '打印个数'
                                // }
                            }
                        });
                    

                } else {
                    this.$message.error('获取失败')
                }
            },
            initStepPrintItems(){
                
            },
            handlePrint(){
                this.$refs.printForm.validate(valid => {
                    if (valid) {
                        // 遍历 printItems 并更新每个表单项的 value
                        this.printItems = this.printItems.map(item => {
                            let value = this.printForm[item.keyCode] || '';
                            if (moment.isMoment(value)) {
                                // 使用 moment.js 格式化日期
                                value = value.format('YYYY-MM-DD HH:mm:ss');
                                } else if (value instanceof Date) {
                                // 如果 value 是 Date 对象，使用 moment.js 格式化日期
                                value = moment(value).format('YYYY-MM-DD HH:mm:ss');
                                } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                                // 如果 value 是类似 '2025-01-15' 的字符串，添加时间部分
                                value = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
                                }
                            return {
                                ...item,
                                keyValue: value
                            };
                        });
                        console.log(this.printItems, 'printItems after submit=================');
                        // this.params = this.printItems.map(item => ({
                        //     keyName: item.keyName,
                        //     keyValue: item.keyValue,

                        // }));
                        // 这里可以处理打印逻辑
                        this.currentStep = 3;
                        this.getGenerateCodeForPrint()
                        // this.getAllModules() // 获取所有模版信息
                    } else {
                        console.log('表单验证失败');
                        return false;
                    }
                });
            },
            // 获取所有产品列表
            async getGenerateCodeForPrint(){
                const params = {
                    // ruleId: this.ruleId,
                    ruleId: this.objectId,
                    number: this.number,
                    params: JSON.stringify(this.printItems)
                }
                const res = await generateCodeForPrint(params)
                if( res.code == 200 && res.success == true ){
                    // this.getModuleInfo.forEach(item => {
                    //     item.code = res.result.code
                    //     item.codeList = res.result.codeList
                    // })
                    this.printList = res.result
                    this.getAllModules() 
                    console.log(res.result,'获取的============产品列表===============')
                } else {
                    this.$message.error(res.message)
                }
            },
            // 获取所有模版信息
            async getAllModules(){
                const res = await getAllModules()
                console.log(res,'获取的============模版列表===============')
                // 根据uuid  106c9a658773405f88795675ad9bc897值去查res.data里返回的列表，获取出uuid=106c9a658773405f88795675ad9bc897的所有数据
                if( res.code == 200 && res.success == true ){
                    this.getModuleInfo = res.result.filter(item => item.uuid === '106c9a658773405f88795675ad9bc897')
                    console.log(this.getModuleInfo,'获取的============模版列表===============')
                    // startPrint(this.printList, this.getModuleInfo, this.number,doneApi,runner,{pageNumber:i,limit})

                    // 确保在获取到模版信息后调用 startPrint 方法
                    if ( this.printList && this.getModuleInfo ) {
                        const runner = new TaskRunner();
                        runner.setConcurrency(1);
                        const tasks = [];
                        const limit = 500;
                        const pageNumber = Math.ceil(this.printList.length / limit);

                        for (let i = 1; i <= pageNumber; i++) {
                            tasks.push(async (doneApi) => {
                            try {
                                const beginNumber = (i - 1) * limit;
                                const endNumber = i * limit;
                                const pagePrintList = this.printList.slice(beginNumber, endNumber);
                                // 获取的打印列表this.printList
                                // 获取的打印模版信息this.getModuleInfo
                                // 打印数量this.n umber
                                const copies = 1
                                startPrint(this.printList, this.getModuleInfo[0], copies, doneApi, runner, { pageNumber: i, limit });
                            } catch (error) {
                                this.$message.error('打印失败: ' + error.message);
                                console.log(error.message,'error.message================')
                                doneApi(); // 确保任务完成
                            }
                            });
                        }

                        runner.addMultiple(tasks);
                    }

                } else {
                    this.$message.error('获取模版列表失败')
                }
            },
            // 获取码段列表
            async getCodeSegmentList(){
                const params = {
                    materialId: this.metarialInfo,
                    processId: this.processId, // 工序ID
                    craftlId: this.craftId,
                    pageSize: 10,
                    currentPage: 1
                }
                const res = await getCodeSegmentList(params)
                console.log(res,'码段列表===============')
                if( res.code == 200 && res.success == true ){
                    this.getProductCode = res.result.records
                } else {
                    this.$message.error('获取码段列表失败')
                }
                
            },
            // 第三部提交
            handleScan(){
                this.newItems = this.flattenItems(this.traceFormItems);
                this.submit()
                console.log(this.newItems,'提交数据==============')
                // this.newItems = this.traceFormItems.map(item => {
                //     return {
                //         name: item.label,
                //         code: item.vModel,
                //         value: item.defaultValue
                //     };
                // });
                
            },
            flattenItems(items) {
                let result = [];
                items.forEach(item => {
                // 创建当前 item 的对象
                result.push({
                    name: item.label,
                    code: item.vModel,
                    value: item.defaultValue,
                    options: item.options
                });

                // 如果 item 包含 children，则递归处理 children
                if (item.children && item.children.length > 0) {
                    result = result.concat(this.flattenItems(item.children));
                }
                });
                return result;
            },
            submit(){
                const operatorTime = new Date().getTime()
                const operatorTimeStr = moment(operatorTime).format('YYYY-MM-DD HH:mm:ss');
                const params = {
                    craftId: this.craftId,
                    eventCode: this.eventCodes, // 事件编码
                    formData: this.newItems,
                    objectCodes: this.scanData, // 追溯码列表
                    operatorTime: operatorTimeStr, //操作时间
                    materialId: this.metarialInfo,
                    processId: this.processId,
                    checkType: this.checkType,
                    startCode: this.activeForm.startCode,
                    endCode: this.activeForm.endCode,
                    personCode: 'MA.M9.166.3546769.DCJ0001-S003', //人员码'

                }
                traceSave(params).then(res => {
                    console.log(res,'res==============')
                    if( res.code == 200 && res.success == true ){
                        this.$message.success(res.message)
                        this.currentStep = 3
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            handleCloseSteps(){
                
                // 关闭父组件的modal
                this.$emit('close')
                this.currentStep = 0
            },
            handleActive(){
                this.activeVisible = true
            },
            handleActiveOk(){
                this.activeVisible = false
                this.handleScan()
            },
            handleActiveCancel(){
                this.activeVisible = false
            },
            // 提交需要激活的码段
            submitActive(){

            }
        }
    }                                           
</script>
<style lang="less" scoped>
    .form-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .form-item {
            width: 49%;
        }
    }
    .traceForm-container{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .ant-form-item {
            width: 100%;
        }
    }
    .ensureBox {
        display: inline-block;
        width: 100%;
        justify-content: flex-end;
        border-top: 1px solid #e6e6e6;
        padding-top: 10px;
        margin-top: 10px;
    }
    .scanContent {
        padding: 20px 38px;
    }
    .startScan {
        margin: 20px 20px 10px 38px;
    }
    .completeBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 160px 0 30px 0;
        .completeText {
            width: 100%;
            text-align: center;
            font-size: 20px;
            margin-top: 30px;
        }
    }
</style>
